<template>
  <v-card class="mb-2 mt-2">
    <v-card-title v-if="showTitle">{{ title }}</v-card-title>
    <v-card-text>
      <div class="text-center" v-if="showTemplate">
        <label>Output Format:</label>
        <template-list v-model="selectedTemplateProp" :additional-options="{'regular': 'All Data except properties (default)', 'regwithprops': 'All Data (including properties)'}"
                       :field-container-title="'Your CSV export will contain the following columns:'">
        </template-list>
      </div>

      <v-row v-if="showEmailDownloadBtn">
        <v-col class="pr-0">
          <v-btn class="text-none" color="black" @click="exportData('email')">Email Data</v-btn>
        </v-col>
        <v-col class="text-right pl-0">
          <v-btn class="text-none" color="black" @click="exportData('download')">Download Data</v-btn>
        </v-col>
      </v-row>

      <div v-if="showCsvDownloadLink" class="mt-5">
        <csv-download-link :scan-filter-state-v2="scanFilterStateV2"></csv-download-link>
      </div>

      <div v-if="showReportingBtn" class="mt-2">
        <a href="mailto:bizdev@codereadr.com?subject=Requesting Custom Reporting" class="d-block text-decoration-none w-100">
          <v-btn color="black" class="w-100 text-none">Request Custom Reporting</v-btn>
        </a>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import TaskHelperService from '../service/TaskHelperService';
import crApi from "../service/CrApi";
import securityService from "../service/SecurityService";
import { ref } from 'vue';

const props = defineProps({
  title : {
    type: String,
    default: 'Export a CSV File'
  },
  showTitle : {
    type: Boolean,
    default: true
  },
  selectedTemplate : {
    type: String,
    default: 'regular'
  },
  showTemplate : {
    type: Boolean,
    default: true
  },
  showEmailDownloadBtn : {
    type: Boolean,
    default: true
  },
  showCsvDownloadLink : {
    type: Boolean,
    default: true
  },
  showReportingBtn : {
    type: Boolean,
    default: true
  },
  scanFilterStateV2 : {
    type: Object,
  }
});

const selectedTemplateProp = ref(props.selectedTemplate);

const exportData = async (type: any) => {
  TaskHelperService.modalPlaceholder = 'Please wait...';
  let scanFilter = props.scanFilterStateV2.getParameters();
  let adapterConfig = {};
  let adapterDetails = {};
  let params = {};

  if (type === 'email') {
    adapterConfig['adapterType'] = 'email';

    let adminResponse = await crApi.requestV2('admin/retrieve/', {
      website_token: securityService.getToken()
    });
    if (adminResponse.status === 1) {
      adapterDetails['email'] = adminResponse['admin'][0]['username'];
    }
  }

  params['scanFilter'] = scanFilter;
  if (adapterDetails) {
    adapterConfig['adapterDetails'] = adapterDetails;
  }
  if (adapterConfig) {
    params['adapterConfig'] = adapterConfig;
  }
  params['website_token'] = securityService.getToken();
  let action = type === 'email' ? 'create_export_scan/queue' : 'create_download_scan/queue';
  let response = await crApi.requestV2(`task/${action}/`, params);
  if (response.status === 1) {
    let historyId = response.historyId;
    TaskHelperService.showModal(historyId);
  }
};

</script>

<style scoped lang="scss">

</style>
